import { getField, updateField } from "vuex-map-fields"

const state = {
    customerCreditStatuses: ["Not Sure", "Clear Credit", "Paid Defaults", "Unpaid Defaults", "Discharged Bankrupt"],
    creditScoreTypes: [
        { label: "VedaScore Comprehensive", prop: "vedascore_comprehensive", value: "VSA_2.0_XY_CR" },
        { label: "VedaScore 2.0 Negative", prop: "vedascore_negative_2_0", value: "VSA_2.0_XY_NR" },
        { label: "VedaScore 1.1 Negative", prop: "vedascore_negative_1_1", value: "VS_1.1_XY_NR" },
        { label: "One Score", prop: "onescore", value: "ONE_1.0_XY_CR" }
    ],
}

const getters = {
    getField
}

const mutations = {
    updateField
}

const actions = {}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
